import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function JoinClass() {
  const { joinCode } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("joining");

  useEffect(() => {
    if (user === null) return;
    if (!user) {
      navigate("/");
      return;
    }
    api
      .post(`/classes/join/${joinCode}`)
      .then(() => {
        toast.success("Joined class");
        setStatus("done");
        setTimeout(() => navigate("/dashboard"), 800);
      })
      .catch((e) => {
        toast.error(formatApiError(e));
        setStatus("error");
      });
  }, [user, joinCode, navigate]);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-center">
        <Loader2 className="mx-auto animate-spin text-cyan8r" />
        <div className="mt-4 text-zinc-400">
          {status === "joining" && "Joining class…"}
          {status === "done" && "Joined! Redirecting…"}
          {status === "error" && "Could not join."}
        </div>
      </div>
    </div>
  );
}
